<div class="row">
	<div class="col-xs-9">
		<h1>P-Card Setup</h1>
	</div>
	<div class="col-xs-3">
		<button *ngIf="entity.Id && !isReadOnly" mat-raised-button color="primary" class="pull-right" (click)="openSetup()">Import Mapping</button>
	</div>
</div>
<sl-error-summary [errors]="errors"></sl-error-summary>
<sl-form [model]="entity" [fields]="fields" [options]="options" [form]="form">
	<div class="row actions" *ngIf="form.dirty">
		<button mat-raised-button type="button" (click)="cancelChanges()">Cancel</button>
		<button mat-raised-button color="primary" class="pull-right" type="button" (click)="saveChanges()" [disabled]="!form.valid">Save
			Changes</button>
	</div>
</sl-form>

<purchase-card-import-setup></purchase-card-import-setup>